import React, { FC } from 'react'

import clsx from 'clsx'
import { SnackbarContent } from 'notistack'
import styled from 'styled-components'

import AlertCircleJson from '@style-port/roov-ui-components-core/assets/lottie/alert-circle.json'
import { Lottie } from '@style-port/roov-ui-components-react'
import { Icon } from 'src/components/atoms'

import { Txt } from '../texts/Txt'

const Container = styled.div`
  box-shadow: 0 0.5rem 2rem rgba(0, 0, 0, 0.3);
  border-radius: var(--s-4);
  transition: transform 1s;
`

type ToastType = 'correct' | 'error'

type Props = {
  text: string | React.ReactNode
  type?: ToastType
  icon?: React.ReactNode
  showCloseIcon?: boolean
  onClickClose?: () => void
}

const ToastBase: FC<Props> = ({ text, type = 'correct', icon, showCloseIcon, onClickClose }) => {
  const showIcon = showCloseIcon ?? type === 'error'

  return (
    <Container
      className={clsx(
        'tw-p-s2 tw-flex tw-items-center',
        type === 'error' ? 'tw-bg-errorRed-default' : 'tw-bg-[#24262b]'
      )}
    >
      {icon ?? (
        <Lottie
          animationData={AlertCircleJson}
          className={
            type === 'correct' ? 'tw-text-standardText-secondary' : 'tw-text-inlineText-primary'
          }
          size="2em"
        />
      )}
      <Txt className="tw-text-inlineText-primary tw-ml-s-1 tw-font-bold">{text}</Txt>
      {showIcon && (
        <div
          role="presentation"
          className="tw-cursor-pointer tw-ml-6 tw-p-2"
          onClick={onClickClose}
        >
          <Icon
            size="--s2"
            path="close/soft/line"
            className="tw-ml-s-1 tw-text-inlineText-primary"
          />
        </div>
      )}
    </Container>
  )
}

// Custom snackbar 参考: https://iamhosseindhv.com/notistack/demos#custom-snackbar
// eslint-disable-next-line react/display-name
export const Toast = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  return (
    <SnackbarContent ref={ref}>
      <ToastBase {...props} />
    </SnackbarContent>
  )
})
